<template>
  <div>
    <div v-for="(item, index) in values">
      <div class="card card-body">
        <div class="col-md-12">
          <h5>{{ index + 1 }}. {{ item.text }}</h5>
          <hr/>
        </div>
        <!-- Opções -->
        <assessment-question-option v-model="item.options" :immediateWatch="true"/>

      </div>
    </div>
  </div>
</template>
<script>
import AssessmentQuestionOption from "./AssessmentQuestionOption";

export default {
  components: {
    AssessmentQuestionOption
  },
  props: {
    showButtons: Boolean,
    immediateWatch: false,
    value: ""
  },
  data() {
    return {
      values: [
        {
          text: "",
          options: []
        }
      ]
    };
  },
  created() {
    // usado desta forma para conseguir mostrar os valores no edit. Adicionado immediate: true para mostrar, no add esta como false.
    this.$watch('value', (newData) => {
      this.values = newData;
    },
    { 
      immediate: this.immediateWatch
    })
  },
  // watch: {
  //   value: function(newData) {
  //     this.values = newData;
  //   }
  // },
  methods: {
    updateValue() {
      this.$emit("input", this.values);
    },
    deleteValue() {
      let i = this.values.length - 1;
      if (i > 0) {
        this.values.splice(i, 1);
        this.$emit("input", this.values);
      }
    },
    addValue() {
      this.values.push({});
      this.$emit("input", this.values);
    }
  }
};
</script>
<style>
</style>
